import * as React from "react";
import styles from "./Loading.css";

interface IProps {
  fill?: string;
}

export const Loading = (props: IProps) => {
  return (
    <svg viewBox="0 0 52 14" height="14px" width="52px">
      <g
        stroke="none"
        strokeWidth="1"
        fill={props.fill || "#ffffff"}
        fillRule="evenodd"
      >
        <circle
          className={`${styles.circle} ${styles.circleLoading}`}
          cx="7"
          cy="7"
          r="7"
        />
        <circle
          className={`${styles.circle} ${styles.circleLoading}`}
          cx="26"
          cy="7"
          r="7"
        />
        <circle
          className={`${styles.circle} ${styles.circleLoading}`}
          cx="45"
          cy="7"
          r="7"
        />
      </g>
    </svg>
  );
};
